import styled from "styled-components";

import { getFontSize, getSemanticColor, getSpacing } from "@braze/beacon-styling";

export const HighchartsWrapper = styled.div`
  z-index: 1;
  width: 100%;

  .highcharts-credits {
    display: none;
  }

  /* Highcharts gives these invisible buttons z-index 999. Where a scene resets the container's z-index, that puts
     them above a dropdown laid over the chart. */
  .highcharts-a11y-proxy-element {
    z-index: auto !important;
  }

  .highcharts-container {
    width: 100% !important;
  }

  .highcharts-root {
    width: 100% !important;
  }

  .highcharts-data-table {
    overflow-x: auto;
  }

  .highcharts-data-table table {
    border-collapse: collapse;
    margin-top: ${getSpacing("sm")};
    width: 100%;
    font-size: ${getFontSize("body", "sm")};
  }

  .highcharts-data-table th,
  .highcharts-data-table td {
    padding: ${getSpacing("xs")} ${getSpacing("sm")};
    border: 1px solid ${getSemanticColor("neutral-border-decorative-medium")};
    white-space: nowrap;
    text-align: right;
  }

  .highcharts-data-table th:first-child,
  .highcharts-data-table td:first-child {
    text-align: left;
  }
`;
